import React, { useRef } from "react";

const BaseForm = ({ children, className, id, onSubmit }) => {
  const FormRef = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    const formValues = new FormData(FormRef.current);
    const data = Object.fromEntries(formValues);
    return onSubmit(event, data);
  };

  return (
    <form className={className} id={id} onSubmit={handleSubmit} ref={FormRef}>
      {children}
    </form>
  );
};

export default BaseForm;
